export const ORIGINS = {
    BE: 'bathroom-estimate',
    KE: 'kitchen-estimate',
    FIXR: 'fixr',
    SR: 'solarreviews',
    RC: 'roofingcalculator',
    HM: 'howmuch',
}